export class FirearmAssetMeta {
  /**
   * @var {string}
   */
  make;

  /**
   * @var {string}
   */
  model;

  /**
   * @var {string}
   */
  action;

  /**
   * @var {string}
   */
  type;

  /**
   * @var {string}
   */
  calibre;

  /**
   * @var {int}
   */
  shots;

  /**
   * @var {float}
   */
  barrelLength;

  /**
   * @var {string}
   */
  serialNumber;

  constructor(model = {}) {
    this.make = model.make;
    this.model = model.model;
    this.action = model.action;
    this.type = model.type;
    this.calibre = model.calibre;
    this.shots = model.shots;
    this.barrelLength = model.barrelLength;
    this.serialNumber = model.serialNumber;
  }

  /**
   *
   * @returns {string}
   */
  get title() {
    return `${this.make} ${this.model} ${this.type ?? ''}`.trim();
  }
}
